import { render } from "./CWidgetIcon.vue?vue&type=template&id=0c5c32bf"
import script from "./CWidgetIcon.vue?vue&type=script&lang=js"
export * from "./CWidgetIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__